/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React, { ReactNode, Suspense, useEffect } from "react";
import Wrapper from "../component/Wrapper";
import Main from "../component/Main";
import Content from "../component/Content";
import Loader from "../component/Loader";
import { Outlet } from "react-router-dom";
import Navbar from "../component/navbar/Navbar";
import Sidebar from "../component/sidebar/Sidebar";
import { SidebarItemsType } from "../types/sidebar";
import {
    Warehouse,
    ShoppingBag,
    ShoppingCart,
    Store,
    Ship,
    Activity
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import Footer from "../component/Footer";

interface DashboardProps {
  children?: ReactNode;
}

export const Ares: React.FC<DashboardProps> = ({ children }) => {
    
    const {isAuthenticated, token, userDetail}  = useAuth();


    useEffect(() => {


    }, []);

    const processData = (response: any) => {
        // console.log("==========================================");
        // console.log(response);
        // console.log("==========================================");

    }

    const fetchData = async (url: string, options: { method: string; headers?: HeadersInit; body?: string }, processData?: any) => {
        
        const response = await fetch(url, options);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const responseJson = await response.json();
        processData(responseJson);
          
    };



    let permissionArray:any = [
        {
            href: "/shipments",
            icon: Ship,
            title: "Inbound Shipments",
            children: [                
                {
                    href: "/shipments/manage",
                    title: "Manage",
                },
            ],
        },        
        {
            href: "/m24l",
            icon: Warehouse,
            title: "3PL Management",
            children: [ 
                {
                    href: "/m24l/notifications-new",
                    title: "Error Notifications",
                },                
                {
                    href: "/m24l/return-request",
                    title: "Inbound - Return Request",
                },                                             
                {
                    href: "/m24l/stock-movement-in",
                    title: "Inbound - Retail Returns",
                },
                {
                    href: "/m24l/wholesale-movement-out",
                    title: "Outbound - Wholesale",
                },

                {
                    href: "/m24l/stock-movement-out",
                    title: "Outbound - Retail",
                },
                {
                    href: "/m24l/stock-adjustment",
                    title: "Stock Adjustments",
                },                 
                {
                    href: "/m24l/stock-master",
                    title: "Stock Master",
                },                
            ],
        },
        {
            href: "/retail",
            icon: Store,
            title: "Retail",
            children: [
                {
                    href: "/retail/store-management",
                    title: "Store Management",
                },
            ],
        },
        {
            href: "/reports",
            icon: Activity,
            title: "Reports",
            children: [
                {
                    href: "/reports/sales-analysis",
                    title: "Sales Analysis",
                },
                {
                    href: "/reports/stock-on-hand",
                    title: "Stock On Hand",
                },
            ],
        }
    ]; 
    
    userDetail?.roles.map((role, index) => {
       //console.log(`Role: ${role}, Index: ${index} `)
       if(role === "store_management"){
          permissionArray = [
            {
                href: "/retail",
                icon: Store,
                title: "Retail",
                children: [
                    {
                        href: "/retail/store-management",
                        title: "Store Management",
                    },
                ],
            }
           ]
       }
     });

    // console.log(`This is the user data`,  userDetail);

    const appSection = permissionArray as unknown as SidebarItemsType[];

    const navItems = [
        {
            title: "Channel Managment:",
            pages: appSection,
        }
    ];

    return (
    
        <React.Fragment>
            <Wrapper>
                <Sidebar items={navItems} />
                <Main>
                    <Navbar />
                    {/* <Body /> */}
                    <Content>
                        <Suspense fallback={<Loader />}>
                            {children}
                            <Outlet />
                        </Suspense>
                    </Content>
                    <Footer />
                </Main>
            </Wrapper>
        </React.Fragment>
    )
};
